import './libs/sentry/sentryInit';

import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import '@pfida-finance/ui/fonts/figtree';
import '@pfida-finance/ui/fonts/jeko';
import '@pfida-finance/ui/global.css';
import '@repo/ui/globals.css';
import './globals.css';

import { mifeName } from '@repo/single-spa';
import { captureAttribution, clientEnv, isTenant } from '@repo/utils';
import { registerApplication } from 'single-spa';

import { MaintenanceModeWrapper } from './components/maintenanceModeWrapper';
import { hydrateAuth } from './features/auth/store/authStore';
import { startConsentBridge } from './libs/consentBridge';
import { loadMetaPixel } from './libs/metaPixel';
import { loadOneTrust } from './libs/oneTrust';
import { Router } from './libs/tanstackRouter/router';
import { AppProviders } from './providers';

registerApplication({
  name: mifeName,
  app: () => import(/* @vite-ignore */ mifeName).then((data) => data.vueParcel()),
  activeWhen: ['/'],
});

hydrateAuth();

// Pfida only: consent banner first; campaign read before the router drops it (stored only with
// targeting consent); Pixel revoked until the consent bridge grants it from the Targeting choice
if (isTenant('pfida')) {
  loadOneTrust();
  captureAttribution(window.location.search, window.location.pathname);
  loadMetaPixel({
    pixelId: clientEnv.VITE_META_PIXEL_ID,
    scriptUrl: clientEnv.VITE_META_PIXEL_SCRIPT_URL,
  });
  startConsentBridge();
}

function App() {
  return (
    <AppProviders>
      <MaintenanceModeWrapper>
        <Router />
      </MaintenanceModeWrapper>
    </AppProviders>
  );
}

// Render the app
const rootElement = document.getElementById('app')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement, {
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
  });
  root.render(<App />);
}
